import React, { useState, useEffect } from 'react';
import { ProgressWrapper, BackCircle, ProgressCircle } from './styled.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Progress = (_a) => {
  var _b = _a, {
    size = "md",
    progress = "indeterminate",
    transitionDelay = 850,
    strokeWidth = 3.6
  } = _b, props = __objRest(_b, [
    "size",
    "progress",
    "transitionDelay",
    "strokeWidth"
  ]);
  const center = 44;
  const radius = 22 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const [offset, setOffset] = useState(circumference);
  const [isIndeterminate, setIsIndeterminate] = useState(true);
  useEffect(() => {
    setIsIndeterminate(progress === "indeterminate");
  }, [progress]);
  useEffect(() => {
    if (typeof progress !== "number") {
      return;
    }
    const progressOffset = (1 - progress) * circumference;
    setOffset(progressOffset);
  }, [setOffset, circumference, progress, offset]);
  return /* @__PURE__ */ React.createElement(ProgressWrapper, __spreadProps(__spreadValues({
    size,
    progress,
    title: isIndeterminate ? "Loading" : "Progress"
  }, props), {
    viewBox: "22 22 44 44"
  }), !isIndeterminate && /* @__PURE__ */ React.createElement(BackCircle, {
    cx: center,
    cy: center,
    r: radius,
    fill: "none",
    strokeWidth,
    stroke: "currentColor"
  }), /* @__PURE__ */ React.createElement(ProgressCircle, {
    cx: center,
    cy: center,
    r: radius,
    fill: "none",
    strokeWidth,
    stroke: "currentColor",
    progress,
    strokeDasharray: circumference,
    strokeDashoffset: offset,
    transitionDelay
  }));
};
Progress.displayName = "Progress";

export { Progress };
//# sourceMappingURL=Progress.es.js.map
